// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum RepositoryType {
    Local = 0,
    ObjectStorage = 1,
    ArchiveObjectStorage = 2
}
